import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { SiteHeader, SiteFooter, ScrollManager } from './components/SiteChrome';
import HomePage from './pages/HomePage';
import BrandPage from './pages/BrandPage';
import { useTheme } from './lib/useTheme';
import './App.css';

export default function App() {
  const { theme, toggle } = useTheme();
  return (
    <BrowserRouter>
      <ScrollManager />
      <a className="skip-link" href="#main-content" data-testid="skip-to-content">Skip to content</a>
      <SiteHeader theme={theme} onToggleTheme={toggle} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/brand" element={<BrandPage />} />
        <Route path="*" element={<main id="main-content" className="container not-found" data-testid="not-found"><p className="eyebrow">404 / PAGE NOT FOUND</p><h1>This path ends here.</h1><a href="/" className="text-link" data-testid="not-found-home">Return to 3tched →</a></main>} />
      </Routes>
      <SiteFooter />
      <Toaster position="bottom-right" theme={theme} />
    </BrowserRouter>
  );
}
